<template>
  <v-layout>
    <v-flex xs12>
      <v-form ref="form">
        <v-layout row wrap>
            <v-flex xs4 sm1>
              <v-menu
                ref="startDatePicker"
                :close-on-content-click="false"
                v-model="startDatePicker"
                :return-value.sync="startDate"
                lazy
                transition="scale-transition"
                offset-y>
                <v-text-field
                  slot="activator"
                  v-model="startDate"
                  label="Start Date"
                  style="margin-left: 10px;"
                  readonly
                ></v-text-field>
                <v-date-picker 
                  v-model="startDate" 
                  @input="$refs.startDatePicker.save(startDate)">
                </v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs4 sm1>
              <v-menu
                ref="endDatePicker"
                :close-on-content-click="false"
                v-model="endDatePicker"
                :return-value.sync="endDate"
                lazy
                transition="scale-transition"
                offset-y>
                <v-text-field
                  slot="activator"
                  v-model="endDate"
                  label="End Date"
                  style="margin-left: 20px;"
                  readonly
                ></v-text-field>
                <v-date-picker 
                  v-model="endDate" 
                  @input="$refs.endDatePicker.save(endDate)">
                  </v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs4 sm2>
              <v-text-field
                v-model="networkUrlId"
                label="Net. Url Id"
                style="margin-left: 10px;"
              ></v-text-field>
            </v-flex>

            <v-flex xs6 sm2>
              <v-text-field
                v-model="publisherId"
                label="PublisherId"
                style="margin-left: 20px;"
              ></v-text-field>
            </v-flex>

            <v-flex xs6 sm2>
              <v-autocomplete
                v-model="network"
                :items="networkNames"
                multiple
                label="Network"
                style="margin-left: 20px;">
              </v-autocomplete>
            </v-flex>

            <v-flex xs4 sm1>
              <v-select
                :items="trafficTypes"
                v-model="trafficType"
                multiple
                label="Traffic"
                style="margin-left: 20px;"
              ></v-select>
            </v-flex>

            <v-flex xs4 sm2>
              <v-select
                :items="modelTypes"
                v-model="modelType"
                multiple
                label="Model"
                style="margin-left: 20px;"
              ></v-select>
            </v-flex> 

            <v-flex xs4 sm1>
              <v-select
                :items="clickHours"
                v-model="clickHour"
                multiple
                label="Hour"
                style="margin-left: 20px;margin-right: 10px;"
              ></v-select>
            </v-flex>


        </v-layout>

        <v-layout row wrap>
          
          <v-flex xs6 sm2>
            
            <v-autocomplete
              v-model="country"
              :items="countryNames"
              multiple
              label="Country"
              style="margin-left: 10px;">
            </v-autocomplete>

          </v-flex>
          <v-flex xs6 sm2>

            <v-autocomplete
              v-model="operator"
              :items="operatorNames"
              label="Operator"
              multiple
              style="margin-left: 20px;">

            </v-autocomplete>

          </v-flex>

          <v-flex xs6 sm2>
            <v-autocomplete
              v-model="advertiser"
              :items="advertiserNames"
              multiple
              label="Adv. Name"
              style="margin-left: 20px;">
            </v-autocomplete>
          </v-flex>

          <v-flex xs6 sm2>
            <v-autocomplete
              v-model="advertiserUrlIdName"
              :items="advertiserUrlIdNames"
              multiple
              label="Adv. UrlId"
              style="margin-left: 20px;">
            </v-autocomplete>

          </v-flex>

          <v-flex xs6 sm2>
            <v-select
              :items="groupByList"
              v-model="groupBy"
              label="Group By"
              style="margin-left: 20px;margin-right: 10px;"
            ></v-select>
          </v-flex> 

          <v-flex xs3 sm1>
            <v-btn @click="search" color="primary">Search</v-btn>
          </v-flex>
          <v-flex xs3 sm1>
            <v-btn @click="reset">Reset</v-btn>
          </v-flex>
    
        </v-layout>

      </v-form>
      
      <v-progress-linear v-if="loading" :indeterminate="loading"></v-progress-linear>
      <v-divider v-else></v-divider>
      <div v-if="noRecord" class="title text-xs-center" style="margin-top: 30px;">
        <p> No record found</p>
      </div>

      <!-- If group by is NetworkUrl -->
      <div style="margin-top: 20px;">
    
          <v-layout>
            <v-flex xs12>
            <v-card>
              <v-data-table
                :headers="headers"
                :items="data"
                :disable-initial-sort="true"
                hide-actions
                class="elevation-10"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id}}</td>
                  <td>{{ props.item.networkName }}({{props.item.networkId}})[Payout : {{props.item.networkPyaout}}]</td>
                  <td>{{ props.item.countryName }}({{props.item.countryId}})</td>
                  <td>{{ props.item.operatorName }}({{props.item.operatorId}})</td>
                  <td>{{ props.item.advertiserName }}({{props.item.advertiserId}})</td>
                  <td>{{ props.item.advertiserCampaignName }}({{props.item.advertiserUrlId}})</td>
                  <td>{{ props.item.totalClicks }}</td>
                  <td>{{ props.item.conversionIn }}</td>
                  <td>{{ props.item.conversionOut }}</td>
                  <td>{{ props.item.crIn.toFixed(2) }}</td>
                  <td>{{ props.item.crOut.toFixed(2) }}</td>
                  <td>{{ props.item.ecpm.toFixed(2) }}</td>
                  <td>{{ props.item.totalCost.toFixed(2) }}</td>
                  <td>{{ props.item.revenue.toFixed(2) }}</td>
                  <td>{{ props.item.profit.toFixed(2) }}</td>
                </template>

                <template slot="footer">
                  <tr>
                    <td><strong>Total : </strong></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                     <td></td>
                    <td class="text-xs-left"><strong>{{totalClicks}}</strong></td>
                    <td class="text-xs-left"><strong>{{totalConversionIn}}</strong></td>
                    <td class="text-xs-left"><strong>{{totalConversionOut}}</strong></td>
                    <td></td>
                    <td></td>
                    <td class="text-xs-left"><strong>{{totalEcpm}}</strong></td>
                    <td class="text-xs-left"><strong>{{totalCost}}</strong></td>
                    <td class="text-xs-left"><strong>{{totalRevenue}}</strong></td>
                    <td class="text-xs-left"><strong>{{totalProfit}}</strong></td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
          </v-layout>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>

import axios from 'axios'
import { SERVER_URL } from './../../constant.js'

export default {
  data: () => ({

    startDatePicker: false,
    endDatePicker: false,
    startDate: '',
    endDate: '',

    networkUrlId : null,
    publisherId: '',

    trafficType: [],
    trafficTypes: ['A', 'C', 'I', 'IG'],

    modelType: [],
    modelTypes: ['CPA', 'CPC', 'CPM', 'CPI'],

    clickHour: [],
    clickHours: ['0','1','2','3','4','5','6','7','8','9', '10', '11','12','13','14','15','16','17','18','19','20','21','22','23'],
    
    country: [],
    countries: [],
    countryNames: [],
    searchCountry: null,

    operator: [],
    operators: [],
    operatorNames: [],
    searchOperator: null,
    
    advertiser: [],
    advertisers: [],
    searchAdvertiser: null,
    advertiserNames: [],

    network: [],
    networks: [],
    networkNames: [],

    advertiserUrlIdName: [],
    advertiserUrlIds: [],
    advertiserUrlIdNames: [],

    groupBy: 'NetworkUrl',
    selectedGroupBy: 'NetworkUrl',
    groupByList: [
      'Hour',
      'Country',
      'Operator',
      'Network',
      'NetworkUrl',
      'Advertiser',
      'AdvertiserUrl',
      'Publisher'
    ],

    headers: [
      { text: 'GroupBy(Id)', value: 'id', sortable: false},
      { text: 'Network', value: 'network',sortable: false},
      { text: 'Country', value: 'country',sortable: false },
      { text: 'Operator', value: 'operator',sortable: false},
      { text: 'Advertiser', value: 'advertiser',sortable: false},
      { text: 'CampaignName', value: 'CampaignName',sortable: false},
      { text: 'Total Clicks', value: 'totalClicks'},
      { text: 'Conv. In', value: 'conversionIn'},
      { text: 'Conv. Out', value: 'conversionOut'},
      { text: 'CR In', value: 'crIn'},
      { text: 'CR Out', value: 'crOut'},
      { text: 'ECPM', value: 'cepm'},
      { text: 'Total Cost($)', value: 'totalCost'},
      { text: 'Revenu($)', value: 'revenue'},
      { text: 'Profit($)', value: 'profit'}
    ],
    
    data: [],
    totalClicks: 0,
    totalConversionIn: 0.0,
    totalConversionOut: 0.0,
    totalEcpm: 0.0,
    totalCost: 0,
    totalRevenue: 0,
    totalProfit: 0,
    loading: false,
    noRecord: false
  }),

  created () {
    document.title = 'Report';
    var vm = this;
    vm.dateInitializer();

    Promise.all([
      axios.get(`${SERVER_URL}/advertiser/all`),
      axios.get(`${SERVER_URL}/country/all`),
      axios.get(`${SERVER_URL}/advertiser/allUrl`),
      axios.get(`${SERVER_URL}/network/all`),
    ]).then(results => {
      results[0].data.forEach(val => {
        vm.advertisers.push(val)
        vm.advertiserNames.push(val.name)
      })
      results[1].data.forEach(val => {
        vm.countries.push(val)
        vm.countryNames.push(val.name)
      })
      results[2].data.forEach(val => {
        vm.advertiserUrlIds.push(val.advertiserUrlId)
        vm.advertiserUrlIdNames.push(val.advertiserUrlId + " - " + val.advertiserCampaignName)
      })
      results[3].data.forEach(val => {
        vm.networks.push(val);
        vm.networkNames.push(val.name)
      })
    })
  },
  watch: {
    country (selection, oldSelection) {
      var vm = this;
      vm.operators = [];
      vm.operatorNames = [];
      selection.forEach (val => {
        axios.get(`${SERVER_URL}/operator/bycountry/${val}`)
        .then(res => {
          res.data.forEach(val => {
            vm.operators.push(val);
            vm.operatorNames.push(val.name);
          })
        })
      })
    }
  },

  methods: {
    dateInitializer () {
      let today = new Date();
      this.startDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
      this.endDate = this.startDate;
    },  

    search () {
      this.loading = true;
      this.resetDataTable();
      this.selectedGroupBy = this.groupBy;

      let vm = this;
      
      let selectedCountries = [];
      vm.country.forEach(countryName => {
        selectedCountries.push(vm.countries.find( cntry => cntry.name === countryName))
      })

      let selectedOperators = [];
      vm.operator.forEach(opName => {
        selectedOperators.push(vm.operators.find(op => op.name === opName))
      })

      let selectedAdvertisers = [];
      vm.advertiser.forEach(advName => {
        selectedAdvertisers.push(vm.advertisers.find(adv => adv.name === advName))
      })

      let selectedNetwork = [];
      vm.network.forEach(netName => {
        selectedNetwork.push(vm.networks.find(net => net.name === netName))
      })

      let selectedAdvertiserUrlIds = [];
      vm.advertiserUrlIdName.forEach(advUrlIdName => {
        let advId = Number(advUrlIdName.substr(0, advUrlIdName.indexOf(' - ')));

        selectedAdvertiserUrlIds.push(vm.advertiserUrlIds.find(id => id === advId))
      })

      let start = new Date(this.startDate);
      start.setHours(0);
      start.setMinutes(0);
      start.setSeconds(0);

      let end = new Date(this.endDate);
      end.setHours(23);
      end.setMinutes(59);
      end.setSeconds(59);

      let payload = {
        startTimestamp: start.getTime(),
        endTimestamp: end.getTime(),
        networkUrlId: this.networkUrlId,
        publisherId: this.publisherId,
        trafficType: this.trafficType.map(tt => tt),
        modelType: this.modelType.map(mt => mt),
        clickHour: this.clickHour.map(ch => Number(ch)),
        countryIds: selectedCountries.map(c => Number(c.countryId)),
        operatorIds: selectedOperators.map(o => Number(o.operatorId)),
        networkIds: selectedNetwork.map(n => Number(n.networkId)),
        advertiserIds: selectedAdvertisers.map(a => Number(a.advertiserId)),
        advertiserUrlIds: selectedAdvertiserUrlIds.map(advurid => Number(advurid)),
        groupBy: this.groupBy
      }

      var url = `${SERVER_URL}/report/generate`;
      if (this.groupBy === "Publisher")
        url = `${SERVER_URL}/report/bypublisher`;

      axios.post(url, payload)
      .then(res => {
        
        vm.data = res.data.stats;
        vm.totalClicks = res.data.totalNumberOfClicks;
        vm.totalConversionIn = res.data.totalConversionIn;
        vm.totalConversionOut = res.data.totalConversionOut;
        vm.totalEcpm = res.data.totalECPM.toFixed(2);
        vm.totalCost = res.data.totalAggregateCost.toFixed(2);
        vm.totalRevenue = res.data.totalAggregateRevenue.toFixed(2);
        vm.totalProfit = res.data.totalAggregateProfit.toFixed(2);
        vm.loading = false;
        if (!vm.data.length) {
          vm.noRecord = true;
        }
      });
    },
    resetTableHeader () {
      this.headers = [
        { text: 'GroupBy(Id)', value: 'id',sortable: false},
        { text: 'Network', value: 'network',sortable: false},
        { text: 'Country', value: 'country',sortable: false},
        { text: 'Operator', value: 'operator',sortable: false},
        { text: 'Advertiser', value: 'advertiser',sortable: false},
        { text: 'CampaignName', value: 'CampaignName',sortable: false},
        { text: 'Clicks', value: 'totalClicks'},
        { text: 'ConvIn', value: 'conversionIn'},
        { text: 'ConvOut', value: 'conversionOut'},
        { text: 'CRIn', value: 'crIn'},
        { text: 'CROut', value: 'crOut'},
        { text: 'ECPM', value: 'cepm'},
        { text: 'Cost($)', value: 'totalCost'},
        { text: 'Revenu($)', value: 'revenue'},
        { text: 'Profit($)', value: 'profit'}
      ]
    },
    resetDataTable () {
      this.data = [];
      this.noRecord = false;
      this.totalClicks = 0,
      this.totalConversionIn = 0.0,
      this.totalConversionOut = 0.0,
      this.totalEcpm = 0.0,
      this.totalCost = 0,
      this.totalRevenue = 0,
      this.totalProfit = 0
    },

    reset () {
      //this.$refs.form.reset();
      this.dateInitializer();
      this.networkUrlId = null;
      this.publisherId = "";
      this.trafficType = [];
      this.modelType = [];
      this.clickHour = [];
      this.country = [];
      this.operator = [];
      this.advertiser = [];
      this.advertiserUrlIdName = [];
      this.network = [];
      this.data = [];

      this.groupBy = 'NetworkUrl';
      this.selectedGroupBy = 'NetworkUrl';

      this.totalClicks = 0,
      this.totalConversionIn = 0.0,
      this.totalConversionOut = 0.0,
      this.totalEcpm = 0.0,
      this.totalCost = 0,
      this.totalRevenue = 0,
      this.totalProfit = 0,

      this.loading = false;
      this.noRecord = false;
      // this.resetTableHeader ();
    }
  }
}
</script>

<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/report/ReportDashboard.vue